import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import Button from 'src/components/Button'
import config from 'src/lib/config'
import { useEmblaContext } from 'src/emblaCarousel/EmblaContext'
import React from 'react'

const DemoPage = () => {
	// const navigate = useNavigate()
	const emblaApi = useEmblaContext()

	const next = React.useCallback(() => {
		emblaApi?.scrollTo(1)
	}, [emblaApi])

	return (
		<Container>
			<Title>Be anywhere. <Highlight>Sell anything.</Highlight></Title>
			<Description>
				The all new Micromart™ Smart Store.
				<br />
				Turn any location into a retail opportunity.
			</Description>
			<Button onClick={next} /* onClick={() => navigate('/displays')}*/>
				Start demo
			</Button>
			<VideoContainer>
				<Video
					src="https://res.cloudinary.com/kitchenmate/video/upload/v1773686414/Website/Micromart/Micromart_hero.mp4"
					muted
					autoPlay
					loop
				/>
			</VideoContainer>
		</Container>
	)
}

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	padding: 1rem 5rem 0;
	flex: 1;
	min-height: 0;
	position: relative;
`

export const Title = styled.h1`
	font-size: ${Math.round(85 * config.resize)}px;
	line-height: ${Math.round(100 * config.resize)}px;
	font-weight: bold;
	color: #08372E;
	text-align: center;
	margin: 0px;
	margin-bottom: 10px;
`

export const Highlight = styled.b`
	color: #139051;
`

export const Description = styled.p`
	font-family: 'Gotham', sans-serif;
	font-size: ${Math.round(34 * config.resize)}px;
	line-height: ${Math.round(50 * config.resize)}px;
	text-align: center;
	margin-bottom: ${Math.round(50 * config.resize)}px;
	padding: 0 ${Math.round(400 * config.resize)}px;
	font-weight: 500;
`

export const VideoContainer = styled.div`
	flex: 1;
	min-height: 0;
	width: 100%;
	display: flex;
	align-items: stretch;
	justify-content: center;
	overflow: hidden;
	margin-bottom: -5%;
`

export const Video = styled.video`
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center 35%;
	display: block;
`

export default DemoPage
